import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading'
import PageTracker from '../../../common/PageTrackerHelper'
import forwardAllocationComp from "./forwardallocation";
import ReverseAllocationComp from "./Reverseallocation";
import {NewAllocationConfigFlag as NewAllocationFlag} from '../../../../services/modules/newallocationservices.js';
export default {
  name: 'newallocationpage',
  components: {VueElementLoading, 'forward-allocation' : forwardAllocationComp, 'Reverse-allocation': ReverseAllocationComp
},
  props: [],
  mixins:[PageTracker],
  data() {
    return {
      ActiveTabIndex: 0,
      IsRVP:true,
      IsDelivery:true,
      userDataKey:''
    }
  },
  computed: {

  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes  = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail =JSON.parse(plaintext);
    this.username = userdetail.username;
    this.userid = userdetail.userid;
    this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0]
    this.GetNewAllocationFlags()
  },
  methods: {
    GetNewAllocationFlags(){
      let Payload = {"hubid": this.userHubId }
      NewAllocationFlag(Payload, (result) => {
        if(result.data.data == true){
          this.IsDelivery = true
          this.IsRVP = true
        }
        else if(result.data.data == false){
          this.IsDelivery = false
          this.IsRVP = false
        }
        else{
        this.IsDelivery = (result.data.data.isnewallocationconfig.delivery && result.data.data.isnewallocationconfig.deliveryv2) ? false : result.data.data.isnewallocationconfig.delivery;
        this.IsRVP = result.data.data.isnewallocationconfig.rvp
      }
      })
    },
    }
  }



// WEBPACK FOOTER //
// ./src/views/components/newallocationpage/newallocationpage.component.js